module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_0.1ed74336.png";